export default "__VITE_ASSET__D3Xhpw10__"